import React from 'react';
import { Code2, Database, Container, Workflow, Boxes } from 'lucide-react';
import { techStackData } from '@/data/profile';
import AnimatedSection from './AnimatedSection';

const iconComponents = {
  code: Code2,
  api: Boxes,
  database: Database,
  rabbit: (props) => (
    <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20.7 14.3c.4-.4.7-.9.7-1.5V9c0-.6-.3-1.1-.7-1.5L13 3c-.4-.3-.9-.3-1.3 0l-7.7 4.5c-.4.4-.7.9-.7 1.5v4c0 .6.3 1.1.7 1.5l7.7 4.5c.4.3.9.3 1.3 0l7.7-4.5z" />
      <path d="m12 8-8 4.5M12 8l8 4.5M12 8v9" />
    </svg>
  ),
  container: Container,
  workflow: Workflow
};

const TechStack = () => {
  return (
    <section id="stack" className="py-32 px-4 relative">
      {/* Background gradient orb */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-br from-[#7B61FF]/10 to-[#FF4D8D]/10 rounded-full blur-3xl"></div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        <AnimatedSection animation="fade-up">
          <div className="text-center mb-20 space-y-4">
            <h2 className="text-4xl md:text-5xl font-bold text-white">Stack Technique</h2>
            <p className="text-xl text-[#a0a0a0]">
              Technologies maîtrisées pour vos projets
            </p>
          </div>
        </AnimatedSection>
        
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
          {techStackData.map((tech, index) => {
            const Icon = iconComponents[tech.icon] || Code2;
            const gradients = [
              'from-[#0066FF] to-[#7B61FF]',
              'from-[#7B61FF] to-[#FF4D8D]',
              'from-[#00D4FF] to-[#0066FF]',
              'from-[#0066FF] to-[#00D4FF]',
              'from-[#FF4D8D] to-[#7B61FF]',
              'from-[#7B61FF] to-[#0066FF]',
              'from-[#00D4FF] to-[#7B61FF]'
            ];
            const gradient = gradients[index % gradients.length];
            
            return (
              <AnimatedSection
                key={tech.name}
                animation="scale"
                delay={index * 80}
                className={tech.featured ? 'md:col-span-3 lg:col-span-3' : ''}
              >
                <div className="group relative bg-[#1a1a1a] rounded-2xl p-6 border border-[#2a2a2a] hover:border-opacity-0 transition-all duration-500 hover:-translate-y-2 cursor-pointer h-full">
                  {/* Gradient border on hover */}
                  <div className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-500 p-[2px]`}>
                    <div className="w-full h-full bg-[#1a1a1a] rounded-2xl"></div>
                  </div>
                  
                  <div className="relative z-10 flex flex-col items-center gap-4">
                    <div className={`bg-gradient-to-br ${gradient} rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-500 shadow-lg ${
                      tech.featured ? 'w-16 h-16' : 'w-12 h-12'
                    }`}>
                      <Icon className={`text-white ${
                        tech.featured ? 'w-8 h-8' : 'w-6 h-6'
                      }`} />
                    </div>
                    <span className={`text-white font-semibold text-center group-hover:text-white transition-colors duration-300 ${
                      tech.featured ? 'text-lg' : 'text-sm'
                    }`}>{tech.name}</span>
                  </div>
                </div>
              </AnimatedSection>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TechStack;